module.exports = __webpack_public_path__ + "img/noble6.43bd62ee.png";